import { cn } from '@/lib/utils';

export interface FilterChip<T extends string> {
  value: T;
  label: string;
}

/** Toggle buttons of screens 04 and 05 (« Tous », « Produits transverses »…). */
export function FilterChips<T extends string>({
  options,
  value,
  onChange,
  ariaLabel,
}: {
  options: FilterChip<T>[];
  value: T;
  onChange: (value: T) => void;
  ariaLabel: string;
}) {
  return (
    <div role="group" aria-label={ariaLabel} className="flex flex-wrap gap-1.5">
      {options.map((option) => {
        const active = option.value === value;
        return (
          <button
            key={option.value}
            type="button"
            aria-pressed={active}
            onClick={() => onChange(option.value)}
            className={cn(
              'min-h-8 cursor-pointer rounded-control border px-3 font-[inherit] text-[13px]',
              active ? 'border-primary bg-accent font-bold text-accent-strong' : 'border-border bg-card text-foreground-secondary',
            )}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
}
